const isDevelopment = process.env.NODE_ENV === 'development';

const MENTORZAA_API =
  process.env.REACT_APP_MENTORZAA_API_URL ||
  'https://api.mentorza.com';

const MEET_API = isDevelopment
  ? (
      process.env.REACT_APP_LOCAL_MEET_API_URL ||
      process.env.REACT_APP_MEET_API_LOCAL_URL ||
      'http://localhost:4001'
    )
  : (
      process.env.REACT_APP_MEET_API_URL ||
      'https://meet-api.mentorza.com'
    );

// API Configuration
export const API_CONFIG = {
  MENTORZAA_BACKEND: MENTORZAA_API,
  MEET_FRONTEND: process.env.REACT_APP_MEET_FRONTEND_URL || 'https://meet.mentorza.com',
  MEET_API,

  // Compatibility aliases used by the inherited client. They intentionally
  // default to Mentorzaa so no meeting data can leave the platform.
  BASE_URL: process.env.REACT_APP_LEGACY_CLINICAL_API_URL || MENTORZAA_API,
  NOTIFICATION_URL: process.env.REACT_APP_NOTIFICATION_URL || MENTORZAA_API
};

export const ADMA_API_URL = API_CONFIG.MENTORZAA_BACKEND;
export const MENTORZAA_API_URL = API_CONFIG.MENTORZAA_BACKEND;
export const MEET_API_URL = API_CONFIG.MEET_API;

// Backwards-compatible alias used by Agora token/socket/meeting services.
export const SERVER_URL = MEET_API_URL;
export const NOTIFICATION_URL = API_CONFIG.NOTIFICATION_URL;

// Meet Frontend URL for redirecting
export const MEET_URL = API_CONFIG.MEET_FRONTEND;
